export default __webpack_public_path__ + "static/icon-menstruacion-dis-46da2055dc168768f10c20912c34cb5a.png";